import React, { Fragment, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

// Material-UI Core
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Slide from "@material-ui/core/Slide";
import TransmittalDetailsForm from "../DocumentWorkflow/Transmittal/TransmittalDetailsForm";

import LockScreenLoading from "../LockScreenLoading/LockScreenLoading";
import FullScreenDialog from "./FullScreenDialog";
// Material-UI Element
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";

import { insertRFIReturnComment } from "../../dataSource/rfi";
import { insertTransmittalReturnComment } from "../../dataSource/transmittal";

// Custom Style
import { oceanBlueColor } from "../../styles/jss/cmsMainStyle";
import { confirmDialogStyle } from "../../styles/jss/components/dialog/confirmDialogStyle";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles = makeStyles((theme) => confirmDialogStyle(theme));

const ReturnCommentDialog = (props) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const {
    open,
    dialogTitle,
    dialogContent,
    setOpenDialog,
    stageCode,
    cancelAction,
    returnCommentDialogHandleClose,
    my_rcpt_type,
    rfi_seq,
    xmtl_seq,
    buildAlert,
  } = props;

  const [returncomment, setReturncomment] = useState("");

  const handleInputChange = (event) => {
    setReturncomment(event.target.value);
  };
  const confirmAction = () => {
    let submitBody = {};
    submitBody.returncomment = returncomment;
    submitBody.stageCode = "RETURNED";
    // if (stageCode === "FIRSTAPPROVED") {
    //   submitBody.rcpt_seq = my_rcpt_type.filter(
    //     (obj) => obj.rcpt_category === "SECONDAPPROVER"
    //   )[0].rcpt_seq;
    //   submitBody.rcpt_category = "Second Approver";
    // } else if (stageCode === "SECONDAPPROVED") {
    //   submitBody.rcpt_seq = my_rcpt_type.filter(
    //     (obj) => obj.rcpt_category === "THIRDAPPROVER"
    //   )[0].rcpt_seq;
    //   submitBody.rcpt_category = "Third Approver";
    // } else {
    //   submitBody.rcpt_seq = my_rcpt_type.filter(
    //     (obj) => obj.rcpt_category === "APPROVE"
    //   )[0].rcpt_seq;
    //   submitBody.rcpt_category = "First Approver";
    // }

    submitBody.rcpt_category = "";
    if (rfi_seq !== undefined) {
      insertRFIReturnComment(rfi_seq, submitBody).then((res) => {
        returnCommentDialogHandleClose();
        buildAlert({
          // Alert Type: success, info, warning, error
          type: "success",
          title: "Success Alert",
          content: "The RFI have been returned",
        });
        setOpenDialog(false);
      });
    } else {
      insertTransmittalReturnComment(xmtl_seq, submitBody).then((res) => {
        returnCommentDialogHandleClose();
        buildAlert({
          // Alert Type: success, info, warning, error
          type: "success",
          title: "Success Alert",
          content: "The Transmittal have been returned",
        });
        setOpenDialog(false);
      });
    }
  };

  return (
    <Fragment>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        fullWidth={true}
        // onClose={handleClose}
        aria-labelledby="confirmDialogTitle"
        aria-describedby="confirmDialogDescription"
        PaperProps={{
          style: {
            background:
              "linear-gradient(0deg, " +
              oceanBlueColor[4] +
              ", " +
              oceanBlueColor[0] +
              ")",
          },
        }}
      >
        <DialogTitle id="confilmDialogTitle">{dialogTitle}</DialogTitle>

        <DialogContent>
          <DialogContentText
            id="confirmDialogContent"
            className={classes.content}
          >
            {/* {dialogContent} */}
          </DialogContentText>

          <Grid item xs={12}>
            <Grid>
              <TextField
                className={classes.textField}
                fullWidth={true}
                id={"returncomment"}
                name={"returncomment"}
                label={"Return Reason/Comemnt"}
                type="text"
                size="small"
                variant="outlined"
                onChange={handleInputChange}
                value={returncomment || ""}
              />
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions>
          <Button
            onClick={cancelAction}
            className={classes.actionButton}
            autoFocus
          >
            Cancel
          </Button>

          <Button onClick={confirmAction} className={classes.actionButton}>
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
};

export default ReturnCommentDialog;
